import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const CustomerTestimonials = () => {
  const testimonials = [
  {
    name: 'Sarah Johnson',
    role: 'Beauty Enthusiast',
    image: "/assets/images/template/img-188c0b71.webp",
    alt: 'Professional headshot of Sarah Johnson smiling at camera',
    rating: 5,
    text: 'Bounderlaster has completely transformed my skincare routine. The product quality is exceptional, and the customer service is outstanding!',
    verified: true
  },
  {
    name: 'Emily Chen',
    role: 'Makeup Artist',
    image: "/assets/images/template/img-18ddee3a.webp",
    alt: 'Emily Chen professional portrait with makeup kit',
    rating: 5,
    text: 'As a professional makeup artist, I rely on authentic products. Bounderlaster delivers every time with genuine brands and fast shipping.',
    verified: true
  },
  {
    name: 'Jessica Martinez',
    role: 'Verified Buyer',
    image: "https://images.unsplash.com/photo-1734104834346-d0e3927ee99c",
    alt: 'Jessica Martinez smiling portrait outdoors',
    rating: 5,
    text: 'The best beauty shopping experience online! Love the curated collections and the exclusive deals. Highly recommend!',
    verified: true
  }];


  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-muted/30">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-4xl md:text-5xl font-heading font-bold text-foreground mb-4">

            What Our Customers Say
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-lg text-muted-foreground max-w-2xl mx-auto">

            Join thousands of satisfied customers who trust us for their beauty needs
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials?.map((testimonial, index) =>
          <motion.div
            key={testimonial?.name}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.1 }}
            whileHover={{ y: -8 }}
            className="bg-card border border-border rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300">

              {/* Rating */}
              <div className="flex items-center gap-1 mb-4">
                {[...Array(testimonial?.rating)]?.map((_, i) =>
              <Icon key={i} name="Star" size={18} className="text-amber-500 fill-current" />
              )}
              </div>

              {/* Testimonial Text */}
              <p className="text-muted-foreground mb-6 leading-relaxed">
                "{testimonial?.text}"
              </p>

              {/* Customer Info */}
              <div className="flex items-center gap-4">
                <img
                src={testimonial?.image}
                alt={testimonial?.alt}
                className="w-12 h-12 rounded-full object-cover border-2 border-border" />

                <div>
                  <div className="flex items-center gap-2">
                    <p className="font-semibold text-foreground">{testimonial?.name}</p>
                    {testimonial?.verified &&
                  <Icon name="CheckCircle" size={16} className="text-primary" />
                  }
                  </div>
                  <p className="text-sm text-muted-foreground">{testimonial?.role}</p>
                </div>
              </div>
            </motion.div>
          )}
        </div>

        {/* Trust Stats */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8">

          <div className="text-center">
            <p className="text-4xl font-bold text-primary mb-2">50K+</p>
            <p className="text-muted-foreground">Happy Customers</p>
          </div>
          <div className="text-center">
            <p className="text-4xl font-bold text-primary mb-2">4.9</p>
            <p className="text-muted-foreground">Average Rating</p>
          </div>
          <div className="text-center">
            <p className="text-4xl font-bold text-primary mb-2">98%</p>
            <p className="text-muted-foreground">Satisfaction Rate</p>
          </div>
          <div className="text-center">
            <p className="text-4xl font-bold text-primary mb-2">24/7</p>
            <p className="text-muted-foreground">Customer Support</p>
          </div>
        </motion.div>
      </div>
    </section>);

};

export default CustomerTestimonials;